import { AxiosResponseType, ReportViewType } from '@/shared/types'
import { REPORT_VIEW } from '@/shared/constants'
import {
  commentApi,
  periodontalReportApi,
  screeningReportApi,
} from '@/shared/api'
import { UploadRawFile } from 'element-plus'

export const addComment = async (
  reportType: ReportViewType,
  reportId: number,
  comment: string,
  files: UploadRawFile[]
): AxiosResponseType<any> => {
  switch (reportType) {
    case REPORT_VIEW.plaqueIndex:
      return await commentApi.addComment(reportId, comment, files)
    case REPORT_VIEW.periodontal:
      return await periodontalReportApi.addComment(
        Number(reportId),
        comment,
        files
      )
    case REPORT_VIEW.screening:
      return await screeningReportApi.addComment(
        Number(reportId),
        comment,
        files
      )
  }
}
